import { useEffect, useRef } from 'react';
import { CrossRoundIcon } from '../../helpers/icons';
import { Button } from '../Button';

export const Modal = ({
  children,
  handleClose,
  title = null,
  shouldCloseOnClickOutside = false,
  footerComponent = null,
  // Takes the close button's place in the header. For a modal whose only way
  // out is its own footer, so the cross would be a second, quieter one.
  headerActionComponent = null,
  width = 'sm', // width can be xs, sm, md, lg, full
  // The dialog's own width class. `width` above builds w-min--/w-max--
  // classes that the stylesheet does not generate, so it has never actually
  // sized anything -- every modal has been w--xs. This is the lever that
  // works, and it defaults to what they all already get.
  widthClass = 'w--xs',
  height = '500', // height will be in numbers
  radius = 'sm',
}) => {
  const modalRef = useRef();

  useEffect(() => {
    if (modalRef.current) {
      const refrence = modalRef.current;
      refrence.showModal();
    }
  }, [modalRef]);

  return (
    <div className="position--fixed left--0 top--0 w--full h--full bg--black-400 z-index--sm">
      <dialog
        data-modal
        ref={modalRef}
        className={`dialog-main ${widthClass} h-min--${height} w-min--${width} w-max--${width} m--auto border-full--black-100 radius--${radius}`}
        onClick={(e) => {
          if (!shouldCloseOnClickOutside) {
            e.preventDefault();
            e.stopPropagation();
          } else {
            handleClose();
          }
        }}
        onClose={() => handleClose()}
      >
        {title && (
          <dialog-head
            class="dialog-head h-min--50 p-l--md p-r--md d--flex align-items--center justify-content--between border-bottom--black-100 bg--primary-200"
            onClick={(e) => e.stopPropagation()}
          >
            {<div className="font--md font--600">{title}</div>}
            {headerActionComponent || (
              <button
                type="button"
                className="font--md font--600 text--primary d--flex c--pointer radius--full"
                onClick={() => handleClose()}
              >
                <CrossRoundIcon width={30} height={30} />
              </button>
            )}
          </dialog-head>
        )}
        <dialog-body
          class="dialog-body p--md h--full"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </dialog-body>
        {footerComponent && (
          <dialog-footer
            class="modal-foot h-max--50 h-min--50 p-l--md p-r--md d--flex align-items--center justify-content--between border-top--black-100"
            onClick={(e) => e.stopPropagation()}
          >
            {footerComponent}
          </dialog-footer>
        )}
      </dialog>
    </div>
  );
};

export const ModalCancelButton = ({ cb, label = 'Cancel' }) => {
  return (
    <Button
      type="button"
      variant="contrast"
      color="primary"
      btnClasses="btn"
      onClick={cb}
    >
      {label}
    </Button>
  );
};

export const ModalConfirmButton = ({
  cb,
  label = 'OK',
  type = 'button',
  variant = 'primary',
}) => {
  return (
    <Button
      type={type}
      variant={variant}
      color="white"
      btnClasses="btn"
      onClick={cb}
    >
      {label}
    </Button>
  );
};
